import { render, staticRenderFns } from "./AllPhotosList.vue?vue&type=template&id=bf5433d2"
import script from "./AllPhotosList.vue?vue&type=script&lang=js"
export * from "./AllPhotosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports